import { Card, Table, Tag, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface WoRow {
  id: number
  numero_scheda?: string
  customer_nome?: string
  vehicle_targa?: string
  vehicle_marca?: string
  vehicle_modello?: string
  stato?: string
  numero_sinistro?: string
  compagnia_sinistro?: string
}

const columns = [
  {
    title: 'OdL',
    dataIndex: 'numero_scheda',
    key: 'numero_scheda',
    width: 130,
    render: (v: string, r: WoRow) => (
      <Space size={4}>
        <span style={{ fontWeight: 600, color: '#1677ff' }}>{v ?? '—'}</span>
        {r.customer_nome && <span style={{ color: '#888', fontSize: 12 }}>· {r.customer_nome}</span>}
      </Space>
    ),
  },
  {
    title: 'Veicolo',
    key: 'veicolo',
    render: (_: unknown, r: WoRow) => (
      <Space size={4}>
        {r.vehicle_targa && <Tag color="geekblue" style={{ fontWeight: 600 }}>{r.vehicle_targa}</Tag>}
        <span>{[r.vehicle_marca, r.vehicle_modello].filter(Boolean).join(' ')}</span>
      </Space>
    ),
  },
  {
    title: 'Sinistro / Compagnia',
    key: 'sinistro',
    render: (_: unknown, r: WoRow) => (
      <Space size={4}>
        {r.numero_sinistro && <Tag color="orange">{r.numero_sinistro}</Tag>}
        {r.compagnia_sinistro && <span style={{ fontSize: 12, color: '#555' }}>{r.compagnia_sinistro}</span>}
      </Space>
    ),
  },
]

export function TableWoSinistriWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<WoRow[]>({
    queryKey: ['dashboard', 'wo-sinistri-list'],
    queryFn: async () => {
      const res = await axiosInstance.get('/work-orders/', { params: { sinistro: true, limit: 20 } })
      return res.data?.items ?? []
    },
    staleTime: 30000,
  })

  return (
    <Card size="small" title="OdL sinistri aperti">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 500 }}
        locale={{ emptyText: 'Nessun OdL con sinistro' }}
        onRow={(r) => ({ onClick: () => navigate(`/schede-lavoro/${r.id}`), style: { cursor: 'pointer' } })}
      />
    </Card>
  )
}
